export interface PropertyTypeData {
  legal_type: string
  avg_price: number
  avg_surface_area: number
  transaction_count: number
}

export interface BuildingComplexityData {
  floor_count: number
  avg_price: number
  avg_surface_area: number
  transaction_count: number
}

export interface PropertyCharacteristicsChartLabels {
  performanceMatrix?: string
  performanceMatrixSubtext?: string
  avgSurfaceArea?: string
  avgPrice?: string
  transactions?: string
  complexityIndex?: string
  complexityIndexSubtext?: string
  numberOfFloors?: string
  avgSurfaceAreaM2?: string
  noData?: string
}

export const DEFAULT_PROPERTY_CHARACTERISTICS_CHART_LABELS: PropertyCharacteristicsChartLabels =
  {
    performanceMatrix: 'Property Type Performance Matrix',
    performanceMatrixSubtext: 'Average Surface Area vs Average Price',
    avgSurfaceArea: 'Average Surface Area (m²)',
    avgPrice: 'Average Price',
    transactions: 'Transactions',
    complexityIndex: 'Building Complexity Index',
    complexityIndexSubtext: 'Price and Area by Number of Floors',
    numberOfFloors: 'Number of Floors',
    avgSurfaceAreaM2: 'Average Surface Area (m²)',
    noData: 'No property characteristics data available',
  }

export interface PropertyCharacteristicsChartProps {
  propertyTypeData?: PropertyTypeData[]
  buildingComplexityData?: BuildingComplexityData[]
  loading?: boolean
  error?: string | null
  height?: number
  labels?: Partial<PropertyCharacteristicsChartLabels>
}
